export default function Index() {
  return (
    <div>test3</div>
  );
}